/**
 * Trạng thái sắp xếp
 */
export default {
  /**
   * Giảm dần
   */
  DESC: 1,
  /**
   * Tăng dần
   */
  ASC: 2
};
